import React from 'react';

import { CategoryDashboard } from '../modules/audience-category-dashboard';

const sortingOptions = [
    {
        label: 'Sort by: Name',
        value: 'name',
        direction: 'asc',
    },
    {
        label: 'Sort by: Newest',
        value: '_created',
        direction: 'desc',
    },
    {
        label: 'Sort by: Last Updated',
        value: 'lastRefreshed',
        direction: 'desc',
    },
];

const PDSCustomLayout2 = ({
    audienceSegments,
    onSearch,
    segmentCount,
    goToSegmentBuilder,
    segmentBuilderUrl,
    activeAudience,
    organizationId,
}) => {
    const linkToAudienceTab = {
        pathname: '/audiences/all',
        query: { audienceTab: 'custom_audiences' },
        linkBackLabel: 'Your Custom Audiences',
    };

    return (
        <CategoryDashboard
            audienceSegments={audienceSegments}
            onSearch={onSearch}
            segmentCount={segmentCount}
            createEditAction={() => goToSegmentBuilder(segmentBuilderUrl)}
            activeAudience={activeAudience}
            organizationId={organizationId}
            sortingOptions={sortingOptions}
            description={
                'Curated to reach audiences based on custom timing or location parameters, this segment creates unique groups aligned with specific advertiser needs.'
            }
            title={'Custom Defined'}
            linkToAudienceTab={linkToAudienceTab}
            bannerImagePath={'/images/audience-segments/banners/custom defined-banner.png'}
        />
    );
};

export default PDSCustomLayout2;
